import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';
import { useGroups } from '../contexts/GroupContext';
import { useAuth } from '../contexts/AuthContext';
import GroupAnalytics from '../components/GroupAnalytics';

export default function GroupAnalyticsPage() {
  const { groups, loading, error } = useGroups();
  const { currentUser } = useAuth();

  return (
    <Container maxWidth="lg">
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Group Analytics
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Insights, trends, and metrics across your groups.
        </Typography>
      </Box>

      {error && (
        <Paper sx={{ p: 2, mb: 3 }}>
          <Typography color="error">{error}</Typography>
        </Paper>
      )}

      {!loading && <GroupAnalytics groups={groups} currentUser={currentUser} />}
    </Container>
  );
}
